import fetch from "../fetch";

export default ({ dealCode, trancheId, id }) =>
  fetch({
    method: "DELETE",
    path: `/abs/deals/${dealCode}/tranche-prices/${trancheId}/tranche-ratings/${id}`
  });
